
import * as React from "react"
import * as LabelPrimitive from "@radix-ui/react-label"
import { cn } from "@/lib/utils"
import { Label } from "@/components/ui/label"
import { useFormField } from "./hooks/useFormField"

const FormLabel = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>
>(({ className, ...props }, ref) => {
  // Add safety check to avoid using FormField outside of a form
  try {
    const { error, formItemId } = useFormField()
    return (
      <Label
        ref={ref}
        className={cn(error && "text-destructive", className)}
        htmlFor={formItemId}
        {...props}
      />
    )
  } catch (e) {
    // Fallback for when used outside FormField
    return (
      <Label
        ref={ref}
        className={className}
        {...props}
      />
    )
  }
})
FormLabel.displayName = "FormLabel"

export { FormLabel }
